import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';
import AreaSplineChartWithHeader from './../../component/areaSplineChartWithHeader'
import Utils from './../../component/utils/utils';

class PackageTotalNewRepatByMonthSeriesView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedInterval: 365,

    }

    componentDidMount () {
        Service.event.onFetchSeriesPackagesByMonth.add((data) => {
            console.log("*** On fetch chart data for total, new, repeat packages by month:");
            console.log(data);

            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryListByMonth,
                histogramChartSeriesDataList1: data.chartData.seriesDataListByMonth1,
                histogramChartSeriesDataList2: data.chartData.seriesDataListByMonth2,
                histogramChartSeriesDataList3: data.chartData.seriesDataListByMonth3,
            });
        });

        Service.fetchPackageSeriesByMonth(this.state.selectedInterval);
    }

    componentWillUnmount() {

    }

    constructor() {
        super();
        // setting default attribute values
        this.intervalOptionsByMonth = Utils.intervalOptionsByMonth;
    }

    selectElementChange = (event) => {
        this.setState({ selectedInterval: event.target.value});
        Service.fetchPackageSeriesByMonth(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchPackageSeriesByMonth(this.state.selectedInterval);
    };

    render() {
        return (
            <div>
                { this.state.renderChart ? <AreaSplineChartWithHeader
                    chartTitle = {"Total, New, Repeat Packages by Month For The Last " + /*this.state.selectedInterval*/ 1 + " year"}
                    histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                    histogramChartSeriesDataList = {
                        [{
                            name: 'Total Packages',
                            data: this.state.histogramChartSeriesDataList1
                        },{
                            name: 'New Packages',
                            data: this.state.histogramChartSeriesDataList2
                        },{
                            name: 'Repeat Packages',
                            data: this.state.histogramChartSeriesDataList3
                        }]
                    }
                    selectElementChange = {this.selectElementChange}
                    searchButtonAction = {this.searchButtonAction}
                    selectDropdownValues = {this.intervalOptionsByMonth}
                    yAxisTitle = "Total/New/Repeat Packages"
                    headerIconClass = "fa fa-credit-card"
                /> : '' }
            </div>
        );
    }
}

export default PackageTotalNewRepatByMonthSeriesView;